import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import Section from "views/common/section";
import BankTransferRefundSection from "views/finance/customerRefunds/common/bankTransferRefundSection";
import PayGateRefundSection from "views/finance/customerRefunds/common/payGateRefundSection";
import type RejectedCustomerRefundCandidateDetailViewModel from "viewModels/finance/customerRefunds/rejectedCustomerRefundCandidates/rejectedCustomerRefundCandidateDetailViewModel";

const RefundSection: ViewComponent<RejectedCustomerRefundCandidateDetailViewModel> = observer(({ vm }) => {
  return (
    <Section context={vm.item} title={vm.translate("refund")}>
      {vm.isPayGateRefund ? <PayGateRefundSection vm={vm} /> : <BankTransferRefundSection vm={vm} />}
    </Section>
  );
});

export default RefundSection;
